export var URL_SELL_TRADE_FORM_v2 = "/site/sell-my-car";
export var URL_SELL_TRADE_LANDING_v2 = "/site/sell-my-car-landing";
export var SELL_TRADE_STATUS = {
  UNDER_INSPECTION: 'under_inspection',
  PENDING_BOOKING: 'pending_booking',
  AWAITING_OFFER_APPROVAL: 'awaiting_offer_approval',
  UNDER_NEGOTIATION: 'under_negotiation',
  PURCHASED: 'purchased'
};